import { databases, storage } from '../lib/appwrite';
import { ID, Permission, Role } from 'appwrite';

// ============================================
// BUG REPORT SERVICE
// ============================================

const DATABASE_ID = process.env.REACT_APP_APPWRITE_DATABASE_ID;
const BUGS_COLLECTION_ID = process.env.REACT_APP_APPWRITE_BUGS_COLLECTION_ID;
const BUCKET_ID = process.env.REACT_APP_APPWRITE_BUCKET_ID;

/**
 * Upload an attachment to Appwrite Storage
 * @param {File} file - The file to upload
 * @returns {Promise<string>} - The uploaded file ID
 */
export const uploadBugAttachment = async (file) => {
    try {
        if (!BUCKET_ID) {
            throw new Error('BUCKET_ID is not configured');
        }

        if (!file) return null;

        const response = await storage.createFile(
            BUCKET_ID,
            ID.unique(),
            file
        );

        return response.$id;
    } catch (error) {
        console.error('Error uploading bug attachment:', error);
        throw error;
    }
};

/**
 * Create a new bug report
 * @param {Object} bugData - The bug report data
 * @param {string} userId - The reporter's user ID
 * @returns {Promise<Object>} - Created bug document
 */
export const createBugReport = async (bugData, userId) => {
    try {
        console.log('Creating bug report:', { bugData, userId });

        if (!DATABASE_ID || !BUGS_COLLECTION_ID) {
            throw new Error('Database or Collection ID not configured for Bugs');
        }

        const doc = await databases.createDocument(
            DATABASE_ID,
            BUGS_COLLECTION_ID,
            ID.unique(),
            {
                reporter_id: userId,
                title: bugData.title,
                description: bugData.description,
                category: bugData.category,
                severity: bugData.severity || 'low',
                status: 'reported',
                device_info: bugData.deviceInfo,
                attachment_id: bugData.attachmentId || null,
                admin_notes: null
            },
            [
                Permission.read(Role.user(userId)),
                Permission.update(Role.user(userId)), // Allow user to update their own bug? Maybe.
                Permission.read(Role.any()) // Or admin role? For now, keep it simple.
            ]
        );

        return doc;
    } catch (error) {
        console.error('Error creating bug report:', error);
        throw error;
    }
};
